const emitir_relatorio_de_escolas_com_informacoes_pendentes = [
  {
    path: "/emitir-relatorio-de-escolas-com-informacoes-pendentes",
    name: "emitir_relatorio_de_escolas_com_informacoes_pendentes",
    meta: {
      breadCrumb:
        "Censo Escolar - Relatório de Acompanhamento do Censo Escolar",
      allowedPermissions: ["relatorios_escola_informacoes_pendentes"],
    },
    component: () =>
      import(
        "@/views/EmitirRelatorioDeEscolasComInformacoesPendentes/EmitirRelatorioDeEscolasComInformacoesPendentes.vue"
      ),
  },
];

export { emitir_relatorio_de_escolas_com_informacoes_pendentes };
